import * as youtubeUrls from '$extensionSrc/automations/youtube/youtubeUrls'
import { updatePlatformUserAccountData } from '$extensionSrc/data/platform/platformUserAccountData'
import { StageType } from '$extensionSrc/utils/enums'

import { YOUTUBE_AUTOMATION_STAGE_STATUSES } from './youtubeAutomationStageStatuses'

export const youtubeSetAccountData = [
  {
    type: StageType.ACTION,
    key: 'SET_ACCOUNT_DATA',
    status: YOUTUBE_AUTOMATION_STAGE_STATUSES.INITIALIZING_PLAYBOOK,
    url: youtubeUrls.homeUrl,
    action: async (machineContext, userContext) => {
      const { machineName: platform } = machineContext
      const { userId } = userContext
      if (!userId) {
        return
      }

      return updatePlatformUserAccountData(platform, userId, {})
    },
  },
]

export function isAccountDataGathered(accountData): boolean {
  return Boolean(accountData) && !accountData?.isDeleted
}
